import gql from 'graphql-tag';

export default gql`
  mutation($publicationUrl: URI!, $suggestionsListId: ID!, $query: String!) {
    addSearchSuggestion(
      input: {
        publicationUrl: $publicationUrl
        suggestionsListId: $suggestionsListId
        libraryComment: ""
        query: $query
      }
    ) {
      code
    }
  }
`;
